import styled from "@emotion/styled";
export const RafflesContainer = styled.div`
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 42px;
       // height: 200vh;
        padding-Top: 64px;
        padding-bottom: 64px;

        .component-title-container {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin-bottom: 45px;

            .component-title-txt {
                font-family: "Roboto Condensed";
                font-size: 106px;
                line-height: 124.22px;
                font-weight: bold;
                text-align: center;
                color: #ffffff;
                text-transform: uppercase;

                @media (max-width: 900px) {
                    font-size: 64px;
                    line-height: 75px;
                }
            }

            .component-subtitle-txt {
                font-family: "Roboto Condensed";
                font-size: 24px;
                line-height: 28.13px;
                opacity: 0.5;
                font-weight: 500;
                text-align: center;
                color: #ffffff;
                text-transform: uppercase;

                @media (max-width: 900px) {
                    font-size: 18px;
                    line-height: 21.09px;
                }
            }
        }
    `;